// i18n.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { fetchTranslations } from '../services/firestoreService';
import translationIT from './locales/it.json';

// Inizializzazione di i18n con traduzioni locali come fallback
i18n
  .use(initReactI18next)
  .init({
    resources: {
      it: {
        translation: translationIT
      }
    },
    lng: 'it',
    fallbackLng: 'it',
    interpolation: {
      escapeValue: false
    }
  });

// Carica le traduzioni da Firestore
export const loadTranslations = async () => {
  try {
    const translations = await fetchTranslations('it');
    i18n.addResourceBundle('it', 'translation', translations, true, true);
    return true;
  } catch (error) {
    console.error('Error loading translations:', error);
    return false;
  }
};

// Carica le traduzioni all'avvio dell'applicazione
loadTranslations();

export default i18n;
